import { styled } from 'styled-components';

import { api } from 'common';

import { Col, Row } from 'react-bootstrap';

import { Badge } from '@vivaahealth/design-system';

interface Props {
  preference?: api.ProviderOrganizationPreference.Preference | null;
}

const Preferences: React.FC<Props> = ({ preference }) => {
  if (
    !preference?.acceptsNewPatients &&
    !preference?.offersOnlineScheduling &&
    !preference?.offersOnlineScheduling
  ) {
    return null;
  }
  return (
    <PreferenceRow className="gy-1 px-2">
      <Col xs="auto" className="px-0">
        {preference?.acceptsNewPatients ? (
          <StyledBadge variant="primary">Accepting new patients</StyledBadge>
        ) : null}
      </Col>
      <Col xs="auto" className="px-0">
        {preference?.offersVirtualVisits ? (
          <StyledBadge variant="primary">Offers virtual visits</StyledBadge>
        ) : null}
      </Col>
      <Col xs="auto" className="px-0">
        {preference?.offersOnlineScheduling ? (
          <StyledBadge variant="primary">Offers online scheduling</StyledBadge>
        ) : null}
      </Col>
    </PreferenceRow>
  );
};

export default Preferences;

const PreferenceRow = styled(Row)`
  padding-bottom: 12px;
  @media (min-width: 636px) {
    padding-top: 4px;
  }
`;

const StyledBadge = styled(Badge)`
  margin: 0 1.5px;
`;
